import createFetchClient, { type Middleware } from 'openapi-fetch'
import createApiClient from 'openapi-react-query'
import type { paths } from './openapi'

export const AUTH_FAILED_EVENT = 'litmers:auth-failed'
export const BEARER_STORAGE_KEY = 'litmers.bearer'

const authMiddleware: Middleware = {
  async onRequest({ request }) {
    const token =
      typeof window === 'undefined'
        ? null
        : window.localStorage.getItem(BEARER_STORAGE_KEY)
    if (token) request.headers.set('authorization', `Bearer ${token}`)
    return request
  },
  async onResponse({ response }) {
    if (response.status === 401 && typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent(AUTH_FAILED_EVENT))
    }
    return response
  },
}

const baseUrl = import.meta.env.VITE_API_URL ?? 'http://localhost:8787'

export const fetchClient = createFetchClient<paths>({
  baseUrl,
})

fetchClient.use(authMiddleware)

export const $api = createApiClient(fetchClient)

export const apiBaseUrl = baseUrl
